export const isPositiveInteger = (value: string): boolean => {
  const number: number = Number(value)
  return Number.isInteger(number) && number >= 0
}
